import { render, staticRenderFns } from "./HeaderSearchApp.vue?vue&type=template&id=c03c96ee&"
import script from "./HeaderSearchApp.vue?vue&type=script&lang=ts&"
export * from "./HeaderSearchApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports